<template>
  <a
    v-if="isExternalLink"
    v-bind="$attrs"
    :href="textToSafeHtml(to)"
    target="_blank"
    rel="noopener">
    <slot />
  </a>
  <router-link
    v-else
    v-bind="$attrs"
    :to="to"
    :parentActive="parentActive"
    :exactActive="exactActive"
    :class="extraClass">
    <slot v-bind="{ ...$props, parentActive, exactActive,isActive, href, navigate }"></slot>
  </router-link>
</template>

<script>
import { RouterLink, useLink } from "vue-router";

export default {
  name: "SaffronLink",
  inheritAttrs: false,
  props: {
    ...RouterLink.props,
    inactiveClass: String,
  },
  setup(props) {
    return useLink(props);
  },
  data: function () {
    return {};
  },
  computed: {
    isExternalLink() {
      return typeof this.to === "string" && this.to.startsWith("http");
    },
    extraClass() {
      let routeValue = this.$router.currentRoute.value;

      if (!this.route.name) {
        return "";
      }

      if (!routeValue?.meta?.saffronPageParents) {
        return "";
      }

      let parentNames = routeValue.meta.saffronPageParents;

      if (!parentNames) {
        return "";
      }
      if (parentNames.includes(this.route.name)) {
        return config.router.linkActiveClass;
      } else {
        return "";
      }
    },
    parentActive() {
      let routeValue = this.$router.currentRoute.value;
      let parentNames = routeValue.meta.saffronPageParents;

      if (!parentNames) {
        return false;
      }

      return parentNames.includes(this.route.name);
    },
    exactActive() {
      let res = this.$router.currentRoute.value.name == this.route.name;
      return res;
    },
  },

  mounted() {},
};
</script>
